export { default } from './CategoryGraphSection';
